import { gql, TypedDocumentNode } from "@apollo/client";

import { QuerySearchReposArgs, SearchReposOutput } from "types/generated";

import { SPACELIFT_VCS_REPO_BASIC_FRAGMENT } from "../gql";

export const SEARCH_SPACELIFT_VCS_REPOS: TypedDocumentNode<
  { searchRepos: SearchReposOutput },
  QuerySearchReposArgs
> = gql`
  query SearchSpaceliftVcsRepos($input: SearchInput!) {
    searchRepos(input: $input) {
      edges {
        cursor
        node {
          ...SpaceliftVcsRepoBasic
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
  ${SPACELIFT_VCS_REPO_BASIC_FRAGMENT}
`;
